import React from 'react';
import { DashboardSidebar } from './DashboardSidebar';

interface MenuItem {
  id: string;
  label: string;
  icon: React.ComponentType<any>;
  description: string;
}

interface DashboardLayoutProps {
  title: string;
  menuItems: MenuItem[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  children: React.ReactNode;
  sidebarBottom?: React.ReactNode;
}

export function DashboardLayout({ 
  title, 
  menuItems, 
  activeTab, 
  onTabChange, 
  children,
  sidebarBottom
}: DashboardLayoutProps) {
  return (
    <div className="min-h-screen bg-white flex relative">
      <DashboardSidebar
        title={title}
        menuItems={menuItems}
        activeTab={activeTab}
        onTabChange={onTabChange}
      >
        {sidebarBottom}
      </DashboardSidebar>

      <div className="flex-1 overflow-auto">
        <div className="p-6 max-w-7xl mx-auto">
          {children}
        </div>
      </div>
    </div>
  );
}
